import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { CompanySubscriptionPlanDocument } from './graphql/companySubscriptionPlan.gql';

export const useCompanySubscriptionPlan = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is required in useCompanySubscriptionPlan',
    );
  }

  return useQuery(CompanySubscriptionPlanDocument, {
    variables: {
      companyProfileId: companyProfileId,
    },
  });
};
